<!-- @format -->

@if (location() !== 'PDP') {
	<div
		role="button"
		tabindex="0"
		class="icon hmf-round-radius"
		[attr.aria-label]="
			isAuthenticated()
				? productIsFavorited()
					? 'Remove from a list'
					: 'Add to a list'
				: 'Sign in to add to a list'
		"
		[ngClass]="{ disablePointerEvents: actionInProgress }"
		(click)="determineFavoritesAction()">
		<homefield-icon
			class="icon-outlined"
			[ngClass]="{ 'icon-filled': productIsFavorited() }"
			[name]="iconName()">
		</homefield-icon>
	</div>
} @else {
	<button
		hmf-button
		class="pdp-icon hmf-sharp-radius pdp-icon-button-text hmf-display-block hmf-text-align-center hmf-py-xxs hmf-py-md-m hmf-px-md-s"
		[class.icon-filled]="productIsFavorited()"
		[variant]="'secondary'"
		[loading]="false"
		[disabled]="!listsEnabled && actionInProgress"
		[label]="pdpButtonLabel()"
		[icon]="iconName()"
		(click)="determineFavoritesAction()">
		{{ pdpButtonText() }}
	</button>
}
